import keycloak from '../auth/keycloak';
import { ensureSessionToken, verifySession } from '../auth/tokenRecovery';
import { REFRESH_TOKEN_MIN_VALIDITY } from '../auth/constants';
import { createHttpClient } from './httpClient';

export * from './apiErrors';
export type { HttpResponseInterface } from './httpClient';

let connectionStatusHandler: ((online: boolean) => void) | undefined;

// The application wires this callback before starting its sagas.
export function setApiConnectionStatusHandler(
  handler: (online: boolean) => void,
) {
  connectionStatusHandler = handler;
  return () => {
    if (connectionStatusHandler === handler)
      connectionStatusHandler = undefined;
  };
}

export const { get, post, put, remove, requestRaw, getBlob } = createHttpClient(
  {
    auth: {
      get authenticated() {
        return keycloak.authenticated;
      },
      get token() {
        return keycloak.token;
      },
      updateToken: ensureSessionToken,
      login: verifySession,
    },
    refreshBeforeRequestByDefault: true,
    refreshTokenMinValidity: REFRESH_TOKEN_MIN_VALIDITY,
    onConnectionStatus: (online) => connectionStatusHandler?.(online),
  },
);
